export const FORFEO_UX_FEEDBACK_VERSION = "4G-G1" as const;

export const FORFEO_UX_FEEDBACK_STATES = [
  "loading",
  "empty",
  "error",
  "offline",
  "success",
] as const;

export type ForfeoUxFeedbackState = (typeof FORFEO_UX_FEEDBACK_STATES)[number];

export const FORFEO_UX_FEEDBACK_POLICY = Object.freeze({
  minimumActionTargetPx: 44,
  loadingUsesBusySemantics: true,
  errorsUseAssertiveAnnouncements: true,
  statusUsesPoliteAnnouncements: true,
  reducedMotionRequired: true,
  rawTechnicalErrorsVisible: false,
  financialAuthority: "GIFTSHOP" as const,
});

export const FORFEO_UX_FEEDBACK_META = Object.freeze({
  loading: { role: "status", live: "polite", busy: true },
  empty: { role: "status", live: "polite", busy: false },
  error: { role: "alert", live: "assertive", busy: false },
  offline: { role: "alert", live: "assertive", busy: false },
  success: { role: "status", live: "polite", busy: false },
} as const);

export function resolveForfeoUxFeedbackMeta(state: ForfeoUxFeedbackState) {
  return FORFEO_UX_FEEDBACK_META[state];
}
